import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { combineLatest, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService, FamilyTreeService } from 'src/app/state';

@Component({
  selector: 'em-material-colour-table',
  styleUrls: ['./material-colour-table.component.less'],
  templateUrl: './material-colour-table.component.html',
  standalone: false,
})
export class MaterialColourTableComponent implements OnInit, OnDestroy {
  public readonly trackByRef = trackByRef;
  public readonly familyTrees$ = this.familyTreeService.familyTrees$;
  public readonly familyTreesLoading$ = this.familyTreeService.loading$;
  public readonly error$ = this.familyTreeService.error$;
  public readonly uiState$ = this.familyTreeService.uiById$;
  public readonly designLoading = this.designService.loading$;

  public readonly loading$ = combineLatest([this.designLoading, this.familyTreesLoading$]).pipe(
    map(([designLoading, familyTreesLoading]) => designLoading || familyTreesLoading)
  );

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly familyTreeService: FamilyTreeService
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((designId) => this.familyTreeService.loadByDesignId(designId)))
        .subscribe()
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
